<cft-holy-grail-grid *transloco="let t">
  <cft-holy-grail-grid-col-left>
    @if (topics$ | async; as topics) {
      <cft-holy-grail-sticky-wrapper>
        <bgo-sidenav-topics class="sticky" [topics]="topics"></bgo-sidenav-topics>
      </cft-holy-grail-sticky-wrapper>
    }
  </cft-holy-grail-grid-col-left>
  <cft-holy-grail-grid-content>
    <div class="plot-lg">{{ t('article.overview.subheading') }}</div>
    <h1 class="heading-2xl md:heading-4xl">{{ t('article.overview.heading') }}</h1>
    <div class="mt-sm grid w-full grid-cols-1 items-center gap-xs no-scrollbar md:grid-cols-2">
      <cft-searchbar
        [formControlInput]="searchControl"
        [placeholder]="t('article.overview.filters.searchText.placeholder')"
      />
      @if (topicList$ | async; as topicList) {
        <cft-filter
          (filterChanged)="topicFilterChanged($event)"
          [placeholder]="t('article.overview.filters.topic.placeholder')"
          [options]="topicList"
          [searchDisabled]="true"
        ></cft-filter>
      }
      @if (authorList$ | async; as authorList) {
        <cft-filter
          (filterChanged)="authorFilterChanged($event)"
          [placeholder]="t('article.overview.filters.author.placeholder')"
          [options]="authorList"
          [searchDisabled]="true"
        ></cft-filter>
      }
    </div>
    @if (articles$ | async; as articles) {
      <h2 class="mt-md plot-md">{{ t('article.overview.numResults', {num: articles.total}) }}</h2>
      <div class="mt-lg">
        <div class="hero-grid-teaser-cards">
          @for (article of articles.items; track article.slug) {
            <bgo-article-preview [isHero]="$index === 0" [article]="article"></bgo-article-preview>
          }
        </div>
        @if (articles.total === 0) {
          <div class="mt-xl text-md">{{ t('article.overview.noContentV2') }}</div>
        }
        @if (articles.items.length < articles.total) {
          <div class="mt-sm flex justify-center">
            <button
              (click)="loadMoreArticles(articles.items.length)"
              cft-button
              [isLoading$]="isLoadingMore$"
              class="btn btn-primary"
            >
              {{ t('article.overview.loadMore') }}
            </button>
          </div>
        }
      </div>
    } @else {
      <div class="mt-2xl flex justify-center">
        <cft-spinner />
      </div>
    }
  </cft-holy-grail-grid-content>
</cft-holy-grail-grid>
